<label class="form-label mb-0" [for]="inputId()">
  @if (label()) {
    {{ label() }}
  }
  <div class="toggle">
    <input
      type="checkbox"
      class="toggle-input"
      [id]="inputId()"
      [ngModel]="_value()"
      (ngModelChange)="onToggle($event)"
      [disabled]="disabled()" />
    <span class="toggle-slider" [class.disabled]="disabled()"></span>
  </div>
</label>
